import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Accordion from "../Containers/Accordion";
import { useSelectorApp } from "../../../lib/redux";
import ContainerKeyValue from "../Containers/ContainerKeyValue";
import { getOrderStatusInfo } from "../../../utils/formats";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import IconButton from "@mui/material/IconButton";
import {
  BRAND,
  CREATORS_OWNER_REPORT_IS_DELIVERY,
  CREATORS_OWNER_REPORT_ORDERS_ARCHIVED,
  CREATORS_OWNER_REPORT_ORDERS_ARCHIVED_EMPTY,
  CREATORS_OWNER_REPORT_WAS_ARCHIVED,
  DATE_LONG,
  NO,
  STATUS,
  VALUE,
  VALUE_WITH_CURRENCY,
  WAS_GENERATED,
  YES,
} from "../../../locales/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";
import { useLocales } from "../../../Contexts/LocaleContext";

const Order = ({ id, data, onUnArchivedOrder, influencer }) => {
  const { shops } = useSelectorApp((state) => state.shop);
  const { t } = useTranslationApp();
  const LOCALES = useLocales();
  const LOCALE = LOCALES[influencer?.signUpCountry || "co"];

  return (
    <Box
      sx={{
        backgroundColor: "background.paperSecondary",
        borderRadius: 3,
        py: 1,
        px: 2,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <IconButton
            sx={{ p: 0, pb: "4px" }}
            onClick={() => onUnArchivedOrder(id)}
          >
            <UnarchiveIcon />
          </IconButton>
        </Box>
        <ContainerKeyValue keyValue="ID: " value={id} />
        <ContainerKeyValue
          keyValue={`${t(BRAND)}: `}
          value={shops[data.shopID]?.businessName ?? "-"}
          redirectURL="shop?shopID"
          redirectValue={data.shopID}
        />
        <ContainerKeyValue
          keyValue={`${t(VALUE)}: `}
          value={`${t(VALUE_WITH_CURRENCY, {
            value: data.value,
            currency: LOCALE.currency,
          })}`}
        />
        <ContainerKeyValue
          keyValue={`${STATUS}: `}
          value={t(getOrderStatusInfo(data.postStatus).label)}
        />

        {data.date && (
          <ContainerKeyValue
            keyValue={`${t(WAS_GENERATED)}: `}
            value={t(DATE_LONG, {
              date: new Date(data.date),
            })}
          />
        )}

        <ContainerKeyValue
          keyValue={`${t(CREATORS_OWNER_REPORT_IS_DELIVERY)}: `}
          value={data.isDelivery ? t(YES) : t(NO)}
        />
        <ContainerKeyValue keyValue="InviteID: " value={data.inviteID} />
        {data.archivedTime && (
          <ContainerKeyValue
            keyValue={`${t(CREATORS_OWNER_REPORT_WAS_ARCHIVED)}: `}
            value={t(DATE_LONG, {
              date: new Date(data.archivedTime),
            })}
          />
        )}
      </Box>
    </Box>
  );
};

const InfluencerOrdersArchived = ({ data, onUnArchivedOrder, influencer }) => {
  const { t } = useTranslationApp();
  const keysSorted = Object.keys(data).sort((a, b) => {
    if (data[a].date === undefined || data[b].date === undefined) return 0;
    return (
      new Date(data[b]?.date)?.getTime() - new Date(data[a]?.date)?.getTime()
    );
  });
  return (
    <Box sx={{ mx: 0, width: "100%" }}>
      <Accordion title={t(CREATORS_OWNER_REPORT_ORDERS_ARCHIVED)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxHeight: 230,
            overflowY: "auto",
            pl: 0,
            pr: 1,
          }}
        >
          {keysSorted.length === 0 ? (
            <Typography>
              {t(CREATORS_OWNER_REPORT_ORDERS_ARCHIVED_EMPTY)}
            </Typography>
          ) : (
            keysSorted.map((orderID) => {
              return (
                <Order
                  key={orderID}
                  id={orderID}
                  data={data[orderID]}
                  onUnArchivedOrder={onUnArchivedOrder}
                  influencer={influencer}
                />
              );
            })
          )}
        </Box>
      </Accordion>
    </Box>
  );
};

export default InfluencerOrdersArchived;
